export enum UserRole {
  USER = 'USER',
  ADMIN = 'ADMIN',
}

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.USER]: 'User',
  [UserRole.ADMIN]: 'Admin',
}; 